<template>
  <div>
    <c-search-form :fields="fields"
                   :form-name="formName"
                   :reload="timeReload"
                   :rows-per-page-items="[10,20,50]"
                   @createNew="openCreateDialog"
                   @editItem="openCreateDialog"
                   @openUserListDialog="openUserListDialog"
                   accept-delete
                   create-url="/groups/save"
                   custom-create-new
                   custom-edit-item
                   delete-url="/groups/delete"
                   formType="intable"
                   key-property="groupId"
                   search-url="/groups/search">

<!--      <c-search-form :fields="fields"-->
<!--                     :form-name="formName"-->
<!--                     :reload="timeReload"-->
<!--                     :rows-per-page-items="[10,20,50]"-->
<!--                     @createNew="openCreateDialog"-->
<!--                     @editItem="openCreateDialog"-->
<!--                     @openUserListDialog="openUserListDialog"-->
<!--                     accept-delete-->
<!--                     create-url="/groups/save"-->
<!--                     custom-create-new-->
<!--                     custom-edit-item-->
<!--                     delete-url="/groups/delete"-->
<!--                     formType="intable"-->
<!--                     key-property="groupId"-->
<!--                     search-url="/call/service?url=http://localhost:8082/groups/search">-->
    </c-search-form>
    <group-create :cDialog="visibleCreateDialog"
                  :propsItem="propsItemCreate"
                  @closeDialog="closeCreateDialog"/>

    <group-user-list
        :cDialog="visibleUserListDialog"
        :timeReload="timeReload"
        :propsItem="propsItemUserList"
        @closeDialog="closeUserListDialog"
        @openUserListWaitingDialog="openUserListWaitingDialog"
    />
    <group-user-list-waiting
        :cDialog="visibleUserListWaitingDialog"
        :timeReload="timeReloadWaiting"
        :propsItem="propsItemUserWaiting"
        @closeDialog="closeUserListWaitingDialog"/>
  </div>


</template>

<script>
  import CSearchForm from "../../../components/form/ManageForm";
  import GroupCreate from "./GroupCreate";
  import GroupUserList from "./GroupUserList";
  import GroupUserListWaiting from "./GroupUserListWaiting";

  export default {
    name: 'groups-list',
    components: {
      GroupUserListWaiting,
      GroupUserList,
      GroupCreate, CSearchForm
    },
    data: () => {
      return {
        formName: "lang.groups.groupForm",
        createFormName: "lang.groups.createGroup",
        propsItemCreate: null,
        visibleCreateDialog: false,
        groupId: -1,
        cDialog: false,
        visibleUserListDialog: false,
        visibleUserListWaitingDialog: false,
        propsItemUserList: null,
        propsItemContactPersonCreate: null,
        timeReload: 0,
        timeReloadWaiting: 0,
        fields: [
          {
            value: "index",
            text: "lang.common.index",
            width: "5%",
            sortable: false,
            headerStyle: "text-align:center"
          },
          {
            value: 'groupName',
            text: 'lang.groups.groupName',
            width: "45%",
            sortable: false,
            headerStyle: "text-align:left"
          },
          {
            value: 'custom_action_list',
            text: "Danh sách nhân viên",
            width: "25%",
            items: [
              {
                text: "Danh sách nhân viên",
                icon: "people",
                event: "openUserListDialog",
                color: "primary"
              },
            ],

          },
          {
            value: 'action',
            text: 'lang.common.actions',
            width: "25%",
            sortable: false,
            compound: true,
            headerStyle: "text-align:center"
          }
        ]
      }
    },
    methods: {

      openCreateDialog: function (item = null) {
        this.propsItemCreate = item;
        this.visibleCreateDialog = true;
      },

      closeCreateDialog: function () {
        this.propsItemCreate = null;
        this.visibleCreateDialog = false;
        this.timeReload = Math.floor(Math.random() * 100);
      },


      openUserListDialog(item) {
        this.propsItemUserList = item;
        this.visibleUserListDialog = true;
      },
      closeUserListDialog: function () {
        this.propsItemUserList = null;
        this.visibleUserListDialog = false;
      },

      openUserListWaitingDialog(item) {
        this.visibleUserListWaitingDialog = true;
        this.propsItemUserWaiting = item;
        this.timeReloadWaiting = Math.floor(Math.random() * 100);
      },

      openContactPersonEditDialog(item) {
        this.visibleUserListWaitingDialog = true;
        this.propsItemUserWaiting = item;
        this.timeReloadWaiting = Math.floor(Math.random() * 100);
      },
      closeUserListWaitingDialog: function () {
        this.visibleUserListWaitingDialog = false;
        this.propsItemUserWaiting = null;
        this.timeReload = Math.floor(Math.random() * 100);
      },
    },
    created() {
    }
  }
</script>
